const UNAUTHORIZED = 401


/**
 * Decides whether a refusal to refresh means the session itself has ended.
 *
 * Only the server refusing the credential ends a session. A timeout, an offline
 * tab or a 502 says nothing about whether the session is still good, and ending
 * one over any of those costs somebody whatever they had unsaved for the sake of
 * a blip.
 *
 * This is deliberately narrower than "any 4xx". A 400 or a 403 is a refusal of
 * the request rather than of the credential it carried, so both point at a bug
 * on our own side, and dressing either up as a logout hides it behind a trip to
 * the login page.
 *
 * @param {Object} refreshError - the error the refresh rejected with
 * @param {Object} [refreshError.response] - the server's answer, absent when
 *   the request never earned one
 * @param {Number} [refreshError.response.status]
 *
 * @returns {Boolean} whether the session has ended
 */
export default function isSessionOver({ response }) {
  return response?.status === UNAUTHORIZED
}
